// extracted by mini-css-extract-plugin
module.exports = {"container":"IssueSample_container_205pk","containerGrid2":"IssueSample_containerGrid2_Vo2cr"};